import router from '../../shared/router';
import ProfileView from './ProfileView';

const {routes} = router.options;
const route = routes.find(r => r.name === 'app');

const tmpRoutes = [
  {
    path: 'profile',
    name: 'profile',
    component: ProfileView,
    meta: {
      requiresAuth: true,
    },
  },
];

tmpRoutes.forEach((obj) => {
  route.children.push(obj);
});

router.addRoutes([route]);